import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "PRODUKTY", -1)
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { class: "flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search mr-2" }, null, -1)
const _hoisted_7 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/mod-stock/products/0",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Pridať produkt",
                severity: "success",
                icon: "pi pi-plus",
                text: "",
                raised: "",
                class: "uppercase"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/mod-stock/import-products" }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Import produktov",
                severity: "success",
                icon: "pi pi-file-excel",
                text: "",
                raised: "",
                class: "uppercase"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_DataTable, {
        lazy: "",
        paginator: "",
        rows: this.pagination.rows,
        onPage: $options.onPage,
        first: this.pagination.first,
        loading: $data.loading,
        totalRecords: this.pagination.totalRecords,
        dataKey: "id",
        value: this.products,
        filters: $data.filters,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (($data.filters) = $event)),
        onFilter: $options.onFilter,
        filterDisplay: "row",
        globalFilterFields: $data.globalFilterFields,
        stripedRows: "",
        "row-hover": "",
        scrollable: "",
        selection: this.selectedproduct,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((this.selectedproduct) = $event)),
        selectionMode: "single",
        metaKeySelection: false,
        onRowSelect: _cache[3] || (_cache[3] = ($event: any) => ($options.showDetail(this.selectedproduct.id))),
        tableStyle: "min-width: 50rem",
        virtualScrollerOptions: { itemSize: 100 },
        scrollHeight: `${this.vh - 420}px`
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_IconField, { iconPosition: "left" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputIcon, null, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputText, {
                  modelValue: $data.filters['global'].value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.filters['global'].value) = $event)),
                  placeholder: "Vyhľadať",
                  onKeydown: _withKeys($options.onFilter, ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("img", {
                src: `${slotProps.data.image}`,
                alt: slotProps.data.image,
                class: "shadow-4 border-round",
                width: "64"
              }, null, 8, _hoisted_7)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "code",
            header: "Kód",
            filterField: "productNumber",
            showFilterMenu: false,
            filterMenuStyle: { width: '6rem' },
            style: {"min-width":"12%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.code), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"6rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Názov",
            filterField: "productName",
            showFilterMenu: false,
            filterMenuStyle: { width: '8rem' },
            style: {"min-width":"12%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.name), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"10rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "producer",
            header: "Výrobca",
            filterField: "productProducer",
            showFilterMenu: false,
            filterMenuStyle: { width: '8rem' },
            style: {"min-width":"12%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.producer), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"10rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "length",
            header: "Dĺžka",
            filterField: "productLength",
            showFilterMenu: false,
            filterMenuStyle: { width: '4rem' },
            style: {"min-width":"7%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.length), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "category.name",
            header: "Kategória",
            filterField: "categoryName",
            showFilterMenu: false,
            filterMenuStyle: { width: '6rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.category.name), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_PrimevueSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                onChange: ($event: any) => (filterCallback()),
                options: this.categoryLabels,
                optionLabel: "label",
                placeholder: "Vyber kategóriu",
                class: "p-column-filter",
                style: {"min-width":"6rem"}
              }, {
                option: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.option.label), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-trash",
                onClick: ($event: any) => ($options.confirmDelete(slotProps.data.id)),
                text: "",
                severity: "danger",
                size: "small"
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  { value: 'Vymazanie produktu' },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rows", "onPage", "first", "loading", "totalRecords", "value", "filters", "onFilter", "globalFilterFields", "selection", "scrollHeight"])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}